import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-between p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-mb-2 p-m-md-0 p-as-md-center" }, "Users")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No customers found. ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-exclamation-triangle p-mr-3",
    style: {"font-size":"2rem"}
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to delete the this user?")
], -1)

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_Toolbar, { key: 0 }, {
          start: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "New",
              icon: "pi pi-plus",
              class: "p-button-success p-mr-2",
              onClick: _ctx.openNew
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, {
      value: _ctx.users,
      responsiveLayout: "scroll",
      loading: _ctx.isLoading
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "id",
          header: "Id"
        }),
        _createVNode(_component_Column, {
          field: "created",
          header: "Created"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.dateTime(data.created)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "lastLogin",
          header: "Last Login"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.dateTime(data.lastLogin)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "Name"
        }),
        _createVNode(_component_Column, {
          field: "isAdmin",
          header: "Admin"
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_Checkbox, {
              modelValue: data.isAdmin,
              "onUpdate:modelValue": $event => ((data.isAdmin) = $event),
              binary: true,
              disabled: true
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "isActive",
          header: "Active"
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_Checkbox, {
              modelValue: data.isActive,
              "onUpdate:modelValue": $event => ((data.isActive) = $event),
              binary: true,
              disabled: true
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        (_ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              exportable: false,
              style: {"min-width":"8rem"},
              header: "Actions"
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-pencil",
                  disabled: data.name==='admin',
                  class: "p-button-rounded p-button-success p-mr-2",
                  onClick: $event => (_ctx.editUser(data))
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  disabled: data.name==='admin',
                  class: "p-button-rounded p-button-warning",
                  onClick: $event => (_ctx.confirmDeleteUser(data))
                }, null, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "loading"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteUsersDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.deleteUsersDialog) = $event)),
      style: {width: '450px'},
      header: "Confirm",
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.deleteUsersDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-text",
          onClick: _ctx.deleteUser
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}